// Chakra imports
import {
    Button,
    Flex,
    HStack,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import React, {useEffect, useState} from "react";
import UserTableRow from "./UserTableRow";
import AddUserModal from "./AddUserModal";
import {approveUser, blockUser, fetchUserDetail, resetPassword, saveUser, searchUser} from "./Services";
import BlockUserModal from "./BlockUserModal";
import UserDetailModal from "./UserDetailModal";
import ResetPasswordModal from "./ResetPasswordModal";

const User = ({title, captions, data}) => {

    const toast = useToast();

    const textColor = useColorModeValue("gray.700", "white");
    const {isOpen, onOpen, onClose} = useDisclosure(); // Modal state management
    const [userList, setUserList] = useState("");
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const [userDetail, setUserDetail] = useState(null);
    const [userId, setUserId] = useState(null);

    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isBlockUserModal, setIsBlockUserModal] = useState(false);
    const [isDetailModal, setDetailModal] = useState(false);
    const [isResetPasswordModal, setResetPasswordModal] = useState(false);
    const [resetPasswordUser, setResetPasswordUser] = useState(null);

    useEffect(() => {
        fetchUserList();
    }, []);

    const fetchUserList = async () => {
        setIsLoadingUsers(true);

        try {
            let request = {
                schoolId: null,
                name: ""
            }
            const response = await searchUser(request, 1, 10);
            if (response.status === 200) {
                const {userList} = response.data
                setUserList(userList);
            }
        } catch (e) {
            console.error("Error while fetching user list e:", e);
        } finally {
            setIsLoadingUsers(false);
        }
    }

    const handleUserSubmit = async (userDetails) => {

        let request = {
            schoolId: Number(userDetails.schoolId),
            fullName: userDetails.fullName,
            address: userDetails.address,
            email: userDetails.email,
            password: userDetails.password,
            mobileNumber: userDetails.phone,
            designation: userDetails.designation,
            description: userDetails.description
        }

        try {
            const response = await saveUser(request);
            console.log(response)
            console.log(response)
            if (response.status === 201) {
                toast({
                    title: "Success!",
                    description: "User details saved successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                onClose();
                fetchUserList();
            }

        } catch (e) {
            console.error("Error while submiting user details e:", e);
        }
    }

    const handleUserBlock = async (id, remarks) => {
        let request = {
            userId: id,
            remarks: remarks.trim(),
        }
        try {
            const response = await blockUser(request);
            if (response.status === 200) {
                toast({
                    title: "Success!",
                    description: "User Blocked successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                setIsBlockUserModal(false);
                fetchUserList();
            }
        } catch (e) {
            console.error("Error while submiting user details e:", e);
        }
    }

    const handleResetPasswordModal = (user, flag) => {
        setResetPasswordUser(flag ? user : null);
        setResetPasswordModal(flag);
    }

    const handleResetPassword = async (userId, newPassword) => {
        let request = {
            userId: Number(userId),
            newPassword: newPassword,
        }

        try {
            const response = await resetPassword(request);
            if (response.status === 200 || response.status === 201) {
                toast({
                    title: "Success!",
                    description: "Password reset successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                handleResetPasswordModal(null, false);
                fetchUserList();
            }
        } catch (e) {
            console.error("Error while resetting password:", e);
            toast({
                title: "Error!",
                description: "Failed to reset password. Please try again.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
            throw e;
        }
    }


    const handeUserUpload = () => {
    }

    const handleApproveModalOpen = () => {
        setIsApproveModalOpen(true);
    }
    const handleApproveModalClose = () => {
        setIsApproveModalOpen(false);
    }

    const handleBlockUserModal = (user, flag) => {
        if (flag === true) {
            setUserId(user.id)
        }
        setIsBlockUserModal(flag);
    }

    const handleUserDetailModal = async (user, flag) => {

        if (flag === true) {
            try {
                let request = {
                    userId: Number(user.id),
                }

                const response = await fetchUserDetail(request);
                if (response.status === 200) {
                    setUserDetail(response.data)
                }

            } catch (e) {
                console.error("Error while trying to handle user approval :{}", e);
            }
        }
        setDetailModal(flag);
    }

    const handleApproveConfirm = async (user) => {
        try {
            let request = {
                userId: Number(user.id),
                remarks: "User Approved"
            }

            const response = await approveUser(request);
            if (response.status === 200) {
                toast({
                    title: "Success!",
                    description: "User approval saved successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                setIsApproveModalOpen(false);
                fetchUserList();
            }

        } catch (e) {
            console.error("Error while trying to handle user approval :{}", e);
        }
    }

    return (
        <Card overflowX={{sm: "scroll", xl: "hidden"}}>
            <CardHeader p="16px 0 24px 0">
                <Flex justify="space-between" align="center" wrap="wrap" gap="12px">
                    {/* Title on the left */}
                    <Text fontSize="lg" color={textColor} fontWeight="semibold" flex="1" isTruncated>
                        {title}
                    </Text>

                    {/* Buttons on the right */}
                    <HStack spacing="3" wrap="wrap">
                        <Button colorScheme="blue" size="sm" onClick={onOpen}>
                            Add User
                        </Button>
                    </HStack>
                </Flex>
            </CardHeader>

            <CardBody>
                <Table variant='simple' color={textColor}>
                    <Thead>
                        <Tr my='.8rem' pl='0px' color='gray.400'>
                            {captions.map((caption, idx) => {
                                return (
                                    <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                                        {caption}
                                    </Th>
                                );
                            })}
                        </Tr>
                    </Thead>
                    <Tbody>
                        <>
                            {isOpen ?
                                <AddUserModal
                                    isOpen={isOpen}
                                    onClose={onClose}
                                    handeUserUpload={handeUserUpload}
                                    handleUserSubmit={handleUserSubmit}
                                /> : ""
                            }
                            {isBlockUserModal ?
                                <BlockUserModal
                                    isOpen={isBlockUserModal}
                                    handleBlockUserModal={handleBlockUserModal}
                                    handleUserBlock={handleUserBlock}
                                    userId={userId}
                                /> : ""
                            }

                            {isDetailModal ?
                                <UserDetailModal
                                    isOpen={isDetailModal}
                                    handleUserDetailModal={handleUserDetailModal}
                                    onClose={handleUserDetailModal}
                                    userDetails={userDetail}
                                /> : ""
                            }
                            {isResetPasswordModal ?
                                <ResetPasswordModal
                                    isOpen={isResetPasswordModal}
                                    onClose={() => handleResetPasswordModal(null, false)}
                                    user={resetPasswordUser}
                                    handleResetPassword={handleResetPassword}
                                /> : ""
                            }
                            {isLoadingUsers && (
                                <Tr>
                                    <Td colSpan={captions.length} py="40px">
                                        <Flex justify="center" align="center" gap="12px">
                                            <Spinner color="blue.400" size="md"/>
                                            <Text color="gray.500" fontSize="sm">Loading users...</Text>
                                        </Flex>
                                    </Td>
                                </Tr>
                            )}
                            {!isLoadingUsers && userList && userList.map((user) => {
                                return (
                                    <UserTableRow
                                        user={user}
                                        isApproveModalOpen={isApproveModalOpen}
                                        handleApproveModalClose={handleApproveModalClose}
                                        handleApproveModalOpen={handleApproveModalOpen}
                                        handleApproveConfirm={handleApproveConfirm}
                                        handleBlockUserModal={handleBlockUserModal}
                                        handleUserDetailModal={handleUserDetailModal}
                                        handleResetPasswordModal={handleResetPasswordModal}
                                    />
                                );
                            })}
                            {!isLoadingUsers && userList && userList.length === 0 && (
                                <Tr>
                                    <Td colSpan={captions.length} py="40px" textAlign="center">
                                        <Text color="gray.500" fontSize="sm">No users found.</Text>
                                    </Td>
                                </Tr>
                            )}
                        </>
                    </Tbody>
                </Table>
            </CardBody>
        </Card>
    );
};

export default User;
